import React from "react";
import ReactDOM from "react-dom";
import UniversityProfile from "./components/university-profile";

const universityProfileContainer = document.getElementById("university-profile");
const dataUniversity = universityProfileContainer.dataset.university;

ReactDOM.render(<UniversityProfile dataUniversity={dataUniversity} />, universityProfileContainer);
